export const GENERAL_CONSTS = {
    GET_LANGUAGES: "GET_LANGUAGES",
    CHANGE_LANGUAGE: "CHANGE_LANGUAGE",
    GET_STATIC_TEXTS: "GET_STATIC_TEXTS",
    GET_MENU: "GET_MENU",
    GET_BADGES: "GET_BADGES",
    GET_CUSTOM_PAGES: "GET_CUSTOM_PAGES",
    GET_BANKS: "GET_BANKS",
    GET_GRAPHICS: "GET_GRAPHICS",
    GET_PARTNERS: "GET_PARTNERS",
    GET_SETTINGS: "GET_SETTINGS",
    GET_SERVICES: "GET_SERVICES",
};
